import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// App-wide login gate (#280). Used as a pathless layout route wrapping
// the protected route tree in App.js.
//
//   * While AuthContext is still resolving /auth/me (loading === true),
//     hold rendering behind a tiny fallback. Without this, a user who
//     refreshes a protected page with a valid stored token would be
//     flashed to /login before the user fetch completes.
//   * Once resolved, an anonymous visitor is redirected to the existing
//     /login screen. The attempted location is stashed in
//     `state.from` so Login.js can bounce them back after sign-in
//     (it already reads location.state?.from with top priority).
//   * An authenticated visitor falls through to <Outlet/> — the matched
//     child route renders normally.
//
// Reuses the existing AuthContext (useAuth) — no new auth machinery.
export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
        Loading…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}
